import { render, staticRenderFns } from "./CartSuccess.vue?vue&type=template&id=cb85c3fa"
import script from "./CartSuccess.vue?vue&type=script&lang=js"
export * from "./CartSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports